<app-dialog
	modalTitle="Selecionar cargo"
	titleButton="Selecionar cargos"
	[hideFooter]="false"
	(dialogClose)="closeModal()"
	(dialogSave)="savePositions()"
>
	<ul class="mb-fix">
		<li>
			<mat-checkbox
				color="primary"
				class="ml-xs mt-quark mb-quark"
				[checked]="masterSelection()"
				(change)="onMasterToggle()"
			>
				Selecionar todos os cargos
			</mat-checkbox>
		</li>
		<li><div class="separator"></div></li>
		<li *ngFor="let position of data.positions; let idx = index">
			<mat-checkbox
				color="primary"
				class="ml-xs mt-quark mb-quark"
				[checked]="resultIds.includes(position.id)"
				(change)="onPositionToggle(position.id, $event.checked)"
			>
				{{ position.name }}
				<span class="gray">{{ positionLabel(idx) }}</span>
			</mat-checkbox>
		</li>
	</ul>
</app-dialog>
